import { createContext, useContext } from "react";

const UserContext = createContext();

export default UserContext;
